function play() {
    document.getElementById('videowrap').innerHTML = '<iframe width="100%" height="100%" src="http://www.youtube.com/embed/iZ4e-95yQUM?autoplay=1" frameborder="0"></iframe>';
}
/*----------------light gallery---------------*/
$(document).ready(function() {
    $("#lightgallery").lightGallery();
    $("#lightgallery1").lightGallery();


});
/*Isotope click function*/
jQuery(document).ready(function () {
    jQuery('.uni-filter ul li').on('click',function(){
        jQuery('.uni-filter ul li').removeClass('active');
        jQuery(this).addClass('active');
        var selector = jQuery(this).attr('data-filter');
        jQuery('.main-iso').isotope({
            filter: selector
        });
        return false;
    });

    jQuery('.product-filter .orderby').on('change', function () {
        var filterValue = this.value;
        jQuery('.product-main-iso').isotope({
            filter: filterValue,

        });

        return false;
    });
    jQuery('.grid').each(function(){
        jQuery('.grid').masonry({
                itemSelector: '.grid-item',
                columnWidth: 200
            });
            var grid = document.querySelector('.grid');
            var msnry = new Masonry( grid, {
                itemSelector: '.grid-item',
                columnWidth: 200
            });
            var msnry = new Masonry( '.grid', {

            });
        
    });

});

/*=======================search time================*/
$(document).ready(function(){
    moment.locale('tr');
    var date1 = new Date();
    var date2 = new Date();
    bugun = moment(date1).format("DD/MM/YYYY");
    bugun = moment(date2).format("DD/MM/YYYY");
    var date_input1=$('input[name="date1"]'); //our date input has the name "date"
    var date_input2=$('input[name="date2"]'); //our date input has the name "date"
    var container=$('.bootstrap-iso form').length>0 ? $('.bootstrap-iso form').parent() : "body";
    var options={
        container: container,
        todayHighlight: true,
        autoclose: true,
        format: 'dd/mm/yyyy',
        language: 'tr',
    };
    date_input1.val(bugun);
    date_input2.val(bugun);
    date_input1.datepicker(options).on('focus', function(date_input1){
    });
    date_input2.datepicker(options).on('focus', function(date_input2){
    });
    $('.input-group').find('.calendar1').on('click', function(){
        if( !date_input1.data('datepicker').picker.is(":visible"))
        {
            date_input1.trigger('focus');
        } else {
        }
    });
    $('.input-group').find('.calendar2').on('click', function(){

        if( !date_input2.data('datepicker').picker.is(":visible"))
        {
            date_input2.trigger('focus');
        } else {
        }
    });
});

/*=======================guest click========================*/
$(document).ready(function () {
    $('.ele-guests ul li').on('click', function(){
        $('.ele-guests ul li').removeClass('active');
        $(this).addClass('active');
        return false;
    });
    $('.ele-adults ul li').on('click', function(){
        $('.ele-adults ul li').removeClass('active');
        $(this).addClass('active');
        return false;
    });
    $('.ele-children ul li').on('click', function(){
        $('.ele-children ul li').removeClass('active');
        $(this).addClass('active');
        return false;
    });
    $('.ele-rooms ul li').on('click', function(){
        $('.ele-rooms ul li').removeClass('active');
        $(this).addClass('active');
        return false;
    });
});

/*===========================shop filter price======================================*/
$(document).ready(function () {
    "use strict";
    $( function() {
        $( "#slider-range" ).slider({
            range: true,
            min: 0,
            max: 1000,
            values: [ 75, 500 ],
            slide: function( event, ui ) {
                $( "#amount" ).val( "$" + ui.values[ 0 ] + " - $" + ui.values[ 1 ] );
            }
        });
        $( "#amount" ).val("$" + $( "#slider-range" ).slider( "values", 0 )+ " - $" + $( "#slider-range" ).slider( "values", 1 ) );
    } );
});

/*========================slide================================*/
$(document).ready(function () {
    $('#uni-page-details-1-slide').owlCarousel({
        loop:true,
        nav:true,
        navText:[],
        dots:false,
        autoplay:true,
        items:1
    });

    $('#uni-details-gallery-slide').owlCarousel({
        center: true,
        loop:true,
        responsive:{
            600:{
                items:2
            }
        }
    });
    $('#uni-silde-widget-slide').owlCarousel({
        loop:true,
        nav:false,
        navText:[],
        dots:true,
        autoplay:true,
        items:1
    });
    $('#uni-post-blig-slide').owlCarousel({
        loop:true,
        nav:true,
        navText:[],
        dots:false,
        autoplay:true,
        items:1
    });
    $('#single-post-slide-you-may-like').owlCarousel({
        loop:true,
        nav:false,
        navText:[],
        dots:true,
        autoplay:true,
        margin:20,
        responsive:{
            0:{
                items:1
            },
            768:{
                items:3
            }
        }
    });
    $('#uni-single-you-may-like-slide').owlCarousel({
        loop:true,
        nav:false,
        navText:[],
        dots:true,
        autoplay:true,
        margin:20,
        responsive:{
            0:{
                items:1
            },
            768:{
                items:3
            }
        }
    });
    $('#uni-middle-our-team-slide').owlCarousel({
        loop:false,
        nav:false,
        navText:[],
        dots:true,
        autoplay:true,
        margin:20,
        items:4,
        responsive:{
            0:{
                items:2
            },
            768:{
                items:3
            }
        }
    });
});

/*====================TOGGLE==================*/
$(document).ready(function() {
    $('.uni-intinerary-tour-left .uni-intinerary-tour-accordion').find('.uni-intinerary-tour-accordion-toggle').on('click', function() {
        $(this).next().slideToggle('600');
        $(".uni-intinerary-tour-accordion-content").not($(this).next()).slideUp('600');
    });
    $('.uni-intinerary-tour-left .uni-intinerary-tour-accordion-toggle').on('click', function() {
        $(this).toggleClass('active').siblings().removeClass('active');
    });
});
$('.uni-leave-your-comment-right .uni-leave-your-comment-right-rating ul li').on('click', function(){
    $('.uni-leave-your-comment-right .uni-leave-your-comment-right-rating ul li').removeClass('active');
    $(this).addClass('active');
    return false;
});

/*============================CLICK INTINERARY TOUR=================================*/
jQuery(document).ready(function ($) {
    $('.hover-element').on('mouseenter', function(){
        $('.show-hover-shortcodes').fadeIn();
    });
    $('.hover-element').on( 'mouseleave',function(){
        $('.show-hover-shortcodes').hide();
    });
    $('.show-hover-shortcodes').on('mouseenter', function(){
        $(this).show();
    });
    $('.show-hover-shortcodes').on('mouseleave',function(){
        $(this).fadeOut();
    });
});

/*============================CLICK LEAVE YOUR COMMENT=================================*/
jQuery(document).ready(function ($) {
    $('.uni-introduction-tour-body  .tab-review').on('click', function(){
        $('.uni-introduction-tour-body .uni-leave-your-comment').show();
        $('.uni-intinerary-tour').hide();
    });
});
/*============================CLICK CHECK TO BOOK=================================*/
jQuery(document).ready(function ($) {
    $('.tab-check-to-book').on('click', function(){
        $('.uni-intinerary-tour').show();
        $('.uni-introduction-tour-body .uni-leave-your-comment').hide();
        $('.check-to-book').addClass('active');
    });
});
/*==================================CLICK OVERVIEW=================================*/
jQuery(document).ready(function ($) {
    $('.tab-overview').on('click', function(){
        $('.uni-leave-your-comment').hide();
        $('.uni-intinerary-tour').hide();
    });
});

/*=================================CLICK GALLERY=================================*/
jQuery(document).ready(function ($) {
    $('.tab-gallery').on('click', function(){
        $('.uni-leave-your-comment').hide();
        $('.uni-intinerary-tour').hide();
    });
});
/*======================replace image single product=============*/
jQuery('.flexslider .product-slide .img-small img').on('click', function($) {
    var value2 = jQuery(this).attr("data-filter2");
    jQuery('.flexslider .product-slide .img-small img').addClass('none');
    jQuery('.filter2').not("."+value2).removeClass('active');
    jQuery('.filter2').filter("."+value2).addClass('active');

});

/*======================CREAT ACCOOUNT===================*/
jQuery('.create-account-label').on('click', function () {
    jQuery('.checkbox-create-account-form').slideToggle();
});

/*=================MENU========================*/
$(document).ready(function () {

    /*----------Menu Dessktop----------------*/
    (function($) {

        $.fn.menumaker = function(options) {

            var cssmenu = $(this), settings = $.extend({
                title: "Menu",
                format: "dropdown",
                sticky: false
            }, options);

            return this.each(function() {

                cssmenu.find('li ul').parent().addClass('has-sub');

                multiTg = function() {
                    cssmenu.find(".has-sub").prepend('<span class="submenu-button"></span>');
                    cssmenu.find('.submenu-button').on('click', function() {
                        $(this).toggleClass('submenu-opened');
                        if ($(this).siblings('ul').hasClass('open')) {
                            $(this).siblings('ul').removeClass('open').hide();
                        }
                        else {
                            $(this).siblings('ul').addClass('open').show();
                        }
                    });
                };

                if (settings.format === 'multitoggle') multiTg();
                else cssmenu.addClass('dropdown');

                if (settings.sticky === true) cssmenu.css('position', 'fixed');

                resizeFix = function() {
                    if ($( window ).width() > 992) {
                        cssmenu.find('ul').show();
                        cssmenu.find('li ul').hide();
                    }

                    if ($(window).width() < 992) {
                        cssmenu.find('ul').hide().removeClass('open');
                    }
                };
                resizeFix();
                return $(window).on('resize', resizeFix);

            });
        };
    })(jQuery);

    /*(function($){
        $(document).ready(function() {
            $("#cssmenu").menumaker({
                title: "Menu",
                format: "multitoggle"
            });

            $("#cssmenu").prepend("<div id='menu-line'></div>");

            var foundActive = false, activeElement, linePosition = 0, menuLine = $("#cssmenu #menu-line"), lineWidth, defaultPosition, defaultWidth;

            $("#cssmenu > ul > li").each(function() {
                if ($(this).hasClass('active')) {
                    activeElement = $(this);
                    foundActive = true;
                }
            });

            if (foundActive === false) {
                activeElement = $("#cssmenu > ul > li").first();
            }

            defaultWidth = lineWidth = activeElement.width();

            defaultPosition = linePosition = activeElement.position().left;

            menuLine.css("width", lineWidth);
            menuLine.css("left", linePosition);

            $("#cssmenu > ul > li").on('mouseenter', function() {
                    activeElement = $(this);
                    lineWidth = activeElement.width();
                    linePosition = activeElement.position().left;
                    menuLine.css("width", lineWidth);
                    menuLine.css("left", linePosition);
                });
            $("#cssmenu > ul > li").on('mouseleave', function() {
                    menuLine.css("left", defaultPosition);
                    menuLine.css("width", defaultWidth);
                });
            $('.vk-menu-mobile-nav #cssmenu_mobile').hide();
            $('.vk-menu-mobile-nav').on('click', function (e) {
                if($(e.target).is('.navbar-toggle .icon-bar i')){
                    $('.vk-menu-mobile-nav #cssmenu_mobile').show();
                    $('#cssmenu_mobile .navbar-nav').show();
                    $(this).hide();
                    return true;
                }
            });

            $('#cssmenu_mobile .uni-icon-close').on('click', function (e) {
                if($(e.target).is('span')){
                    $('.vk-menu-mobile-nav #cssmenu_mobile').hide();
                    return true;
                }
            });

        });
    })(jQuery);*/

    /*----------Menu Mobiles---------------*/
    (function($) {

        $.fn.menumaker = function(options) {

            var cssmenu_mobile = $(this), settings = $.extend({
                title: "Menu",
                format: "dropdown",
                sticky: false
            }, options);

            return this.each(function() {

                cssmenu_mobile.find('li ul').parent().addClass('has-sub');

                multiTg = function() {
                    cssmenu_mobile.find(".has-sub").prepend('<span class="submenu-button"></span>');
                    cssmenu_mobile.find('.submenu-button').on('click', function() {
                        $(this).toggleClass('submenu-opened');
                        if ($(this).siblings('ul').hasClass('open')) {
                            $(this).siblings('ul').removeClass('open').hide();
                        }
                        else {
                            $(this).siblings('ul').addClass('open').show();
                        }
                    });
                };

                if (settings.format === 'multitoggle') multiTg();
                else cssmenu_mobile.addClass('dropdown');

                if (settings.sticky === true) cssmenu_mobile.css('position', 'fixed');

                resizeFix = function() {
                    if ($( window ).width() > 992) {
                        cssmenu_mobile.find('ul').show();
                        cssmenu_mobile.find('li ul').hide();
                    }

                    if ($(window).width() < 992) {
                        cssmenu_mobile.find('ul').hide().removeClass('open');
                    }
                };
                resizeFix();
                return $(window).on('resize', resizeFix);

            });
        };
    })(jQuery);

    (function($){
        $(document).ready(function() {
            $("#cssmenu_mobile").menumaker({
                title: "Menu",
                format: "multitoggle"
            });

            $("#cssmenu_mobile").prepend("<div id='menu-line'></div>");

            var foundActive = false, activeElement, linePosition = 0, menuLine = $("#cssmenu_mobile #menu-line"), lineWidth, defaultPosition, defaultWidth;

            $("#cssmenu_mobile > ul > li").each(function() {
                if ($(this).hasClass('active')) {
                    activeElement = $(this);
                    foundActive = true;
                }
            });

            if (foundActive === false) {
                activeElement = $("#cssmenu_mobile > ul > li").first();
            }

            defaultWidth = lineWidth = activeElement.width();

            defaultPosition = linePosition = activeElement.position().left;

            menuLine.css("width", lineWidth);
            menuLine.css("left", linePosition);

            $("#cssmenu_mobile > ul > li").on('mouseenter', function() {
                    activeElement = $(this);
                    lineWidth = activeElement.width();
                    linePosition = activeElement.position().left;
                    menuLine.css("width", lineWidth);
                    menuLine.css("left", linePosition);
                });
            $("#cssmenu_mobile > ul > li").on('mouseleave', function() {
                    menuLine.css("left", defaultPosition);
                    menuLine.css("width", defaultWidth);
                });
            $('.vk-menu-mobile-nav #cssmenu_mobile').hide();
            $('.vk-menu-mobile-nav').on('click', function (e) {
                if($(e.target).is('.navbar-toggle .icon-bar i')){
                    $('.vk-menu-mobile-nav #cssmenu_mobile').show();
                    $('#cssmenu_mobile .navbar-nav').show();
                    $(this).hide();
                    return true;
                }
            });

            $('#cssmenu_mobile .uni-icon-close').on('click', function (e) {
                if($(e.target).is('span')){
                    $('.vk-menu-mobile-nav #cssmenu_mobile').hide();
                    return true;
                }
            });

        });
    })(jQuery);

    /*--------List Image---------------*/
    $('.list-image .grid').packery({
        itemSelector: '.grid-item',
        resize: false,
        gutter: 20
    });
});

/*=======================HOME 2 PLAY VIDEO===================*/
$(document).ready(function () {
   $('.uni-button-play img').on('click', function () {
       $('.uni-home-2-hot-events .item-caption').hide();
       $('.uni-home-2-hot-events .btn-more-info-out').css('visibility','visible')
   });
});

/*select mobile details*/
$(document).ready(function () {
    $(".uni-introduction-tour-select ul").on("click", ".init", function() {
        $(this).closest(".uni-introduction-tour-select ul").children('li:not(.init)').toggle();
    });

    var allOptions = $(".uni-introduction-tour-select ul").children('li:not(.init)');
    $(".uni-introduction-tour-select ul").on("click", "li:not(.init)", function() {
        allOptions.removeClass('selected');
        $(this).addClass('selected');
        $(".uni-introduction-tour-select ul").children('.init').html($(this).html());
        allOptions.toggle();
    });
});

//------------------------------------slick slider Home 1-----------------------
var Slider = function () {
    var singleProjectSlider = function () {
        $('.vk-slider-project .slider-for').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            nextArrow: '<button  class="vk-btn vk-arrow next"><i class="fa fa-chevron-right"></i></button>',
            prevArrow: '<button  class="vk-btn vk-arrow prev"><i class="fa fa-chevron-left"></i></button>',
            fade: true,
            asNavFor: '.slider-nav',
            focusOnSelect: true,
        });
        $('.vk-slider-project .slider-nav').slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            asNavFor: '.slider-for',
            focusOnSelect: true,
            arrows: false,
            responsive: [{

                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                }

            }]
        });
    };

    var singleProductSlider = function () {
        $('.vk-slider-shop .slider-for').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            arrows: false,
            asNavFor: '.slider-nav',
            adaptiveHeight: true,
        });
        $('.vk-slider-shop .slider-nav').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            asNavFor: '.slider-for',
            focusOnSelect: true,
            nextArrow: '<button  class="vk-btn vk-arrow next"><i class="fa fa-chevron-right"></i></button>',
            prevArrow: '<button  class="vk-btn vk-arrow prev"><i class="fa fa-chevron-left"></i></button>',
        });
    };

    var imageSlider = function () {
        $('.vk-slick-slider').slick({
            nextArrow: '<button  class="vk-btn vk-arrow next"><i class="fa fa-chevron-right"></i></button>',
            prevArrow: '<button  class="vk-btn vk-arrow prev"><i class="fa fa-chevron-left"></i></button>',
            centerPadding: 0,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        arrows: true,
                    }

                }, {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        arrows: false,
                        centerMode: true,
                        centerPadding: '50px',
                    }

                }]
        });
    };

    var homepageSlider = function () {

        $('.recent-blog-slider').slick({
            nextArrow: '<button  class="vk-btn vk-arrow next"><i class="fa fa-chevron-right"></i></button>',
            prevArrow: '<button  class="vk-btn vk-arrow prev"><i class="fa fa-chevron-left"></i></button>',
            slidesToShow: 2,
            dots: true,
            dotsClass: 'vk-arrow-dots',
            responsive: [{

                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    arrows: false
                }

            }]
        })
            .on('setPosition', function (event, slick) {
                arrowDotNav();
            });


    };

    var aboutPageSlider = function () {
        $('.customer-slider').slick({
            nextArrow: '<button  class="vk-btn vk-arrow next"><i class="fa fa-chevron-right"></i></button>',
            prevArrow: '<button  class="vk-btn vk-arrow prev"><i class="fa fa-chevron-left"></i></button>',
            adaptiveHeight: true,
            responsive: [{
                breakpoint: 992,
                settings: {
                    arrows: false
                }

            }]
        });
    };

    var homeShopSlider = function () {

        $('.vk-list-client-shop > .vk-list').slick({
            slidesToShow: 6,
            nextArrow: '<button  class="vk-btn vk-arrow next"><i class="fa fa-angle-right"></i></button>',
            prevArrow: '<button  class="vk-btn vk-arrow prev"><i class="fa fa-angle-left"></i></button>',
            responsive: [{
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                }

            },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                    }

                }]
        });
    };

    var arrowDotNav = function () {
        var arrowDots = $('.vk-arrow-dots');
        if (arrowDots.length > 0) {
            var dots = arrowDots.find('>li');
            var numDots = dots.length;
            dots.css('width', 'calc(100% / ' + numDots + ')')
        }
    };

    var homeOnePage = function () {

        var currentWidth = $(window).outerWidth();

        if (currentWidth >= 768) {

            $('.slick-slider-one-page').addClass('_pc');

            if ($('.slick-slider-one-page.slick-slider').length == 1 && $('.slick-slider-one-page._mobile').length == 1) {
                $('.slick-slider-one-page').slick('destroy');
                $('.slick-slider-one-page').removeClass('_mobile');

            }

            if ($('.slick-slider-one-page._pc').length == 1 && $('.slick-slider-one-page.slick-slider').length == 0) {

                $('.slick-slider-one-page').slick({
                    nextArrow: '<button  class="vk-btn vk-arrow next"><i class="fa fa-chevron-right"></i></button>',
                    prevArrow: '<button  class="vk-btn vk-arrow prev"><i class="fa fa-chevron-left"></i></button>',
                    slidesToShow: 3,
                    rows: 2,
                    responsive: [
                        {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: 2,
                            }
                        }],
                });
            }
        }

        if (currentWidth < 768) {

            $('.slick-slider-one-page').addClass('_mobile');

            if ($('.slick-slider-one-page.slick-slider').length == 1 && $('.slick-slider-one-page._pc').length == 1) {
                $('.slick-slider-one-page').slick('destroy');
                $('.slick-slider-one-page').removeClass('_pc');
            }
            if ($('.slick-slider-one-page._mobile').length == 1 && $('.slick-slider-one-page.slick-slider').length == 0) {
                console.log('MB');
                $('.slick-slider-one-page').slick({
                    nextArrow: '<button  class="vk-btn vk-arrow next"><i class="fa fa-chevron-right"></i></button>',
                    prevArrow: '<button  class="vk-btn vk-arrow prev"><i class="fa fa-chevron-left"></i></button>',
                    slidesToShow: 1,
                    rows: 1,
                });
            }
        }

        if (currentWidth >= 1068){
            $('.slick-slider-left-menu').addClass('_pc');

            if ($('.slick-slider-left-menu.slick-slider').length == 1 && $('.slick-slider-left-menu._mobile').length == 1) {
                $('.slick-slider-left-menu').slick('destroy');
                $('.slick-slider-left-menu').removeClass('_mobile');
            }

            if ($('.slick-slider-left-menu._pc').length == 1 && $('.slick-slider-left-menu.slick-slider').length == 0) {

                $('.slick-slider-left-menu').slick({
                    nextArrow: '<button  class="vk-btn vk-arrow next"><i class="fa fa-chevron-right"></i></button>',
                    prevArrow: '<button  class="vk-btn vk-arrow prev"><i class="fa fa-chevron-left"></i></button>',
                    slidesToShow: 3,
                    rows: 2,
                    responsive: [
                        {
                            breakpoint: 1291,
                            settings: {
                                slidesToShow: 2,
                            }
                        }],
                });
            }
        }

    };

    var homeOnePageExtra = function () {
        $('.vk-slider-testimonial').slick({
            nextArrow: '<button  class="vk-btn vk-arrow next"><i class="ti-angle-right"></i></button>',
            prevArrow: '<button  class="vk-btn vk-arrow prev"><i class="ti-angle-left"></i></button>',
            adaptiveHeight: true
        });

        $('.vk-pricing-table-slider').slick({
            arrows: false,
            adaptiveHeight: true,
            slidesToShow: 4,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                    }
                },
            ],
        });

    }

    var homeSlider = function(){

        var slider = $('.vk-baner-slider');
        var imageArrow = function(){
            var itemSlider = slider.find('.slick-slide');
            var itemSliderCurrent = slider.find('.slick-slide.slick-current');
            var totalSlider = itemSlider.length;
            var imageNext='';
            var imagePrev='';

            if(itemSliderCurrent.attr('data-slick-index') == 0){
                imagePrev = $(itemSlider.last()).css('background-image');
                imageNext = $(itemSliderCurrent).next().css('background-image');
            }

            else if(itemSliderCurrent.attr('data-slick-index') == totalSlider - 1){
                imageNext = $(itemSlider.first()).css('background-image');
                imagePrev = $(itemSliderCurrent).prev().css('background-image');
            }
            else{
                imageNext = $(itemSliderCurrent).next().css('background-image');
                imagePrev = $(itemSliderCurrent).prev().css('background-image');
            }

            return{
                imageNext: imageNext,
                imagePrev: imagePrev,
            }
        }

        slider.on('init', function(event, slick){
            var imageNext = $('.slick-slide.slick-current').next().css('background-image');
            var imagePrev = $('.slick-slide.slick-current').prev().css('background-image');

            $(this).find('.vk-arrow.next .image-preview-thumbnail').css('background-image',imageNext);
            $(this).find('.vk-arrow.prev .image-preview-thumbnail').css('background-image',imagePrev);

            var $firstAnimatingElements = $('.slick-slide').find('[data-animation]');
            doAnimations($firstAnimatingElements);
        });

        slider.on('beforeChange', function(e, slick, currentSlide, nextSlide) {
            var $animatingElements = $('.slick-slide[data-slick-index="' + nextSlide + '"]').find('[data-animation]');
            doAnimations($animatingElements);
            console.log(currentSlide,nextSlide)
        });

        slider.slick({
            nextArrow: '<button  class="vk-btn vk-arrow next"><i class="icon ti-angle-right"></i><span class="image-preview-thumbnail"></span></button>',
            prevArrow: '<button  class="vk-btn vk-arrow prev"><i class="icon ti-angle-left"></i><span class="image-preview-thumbnail"></span></button>',
            dotsClass:'vk-list vk-dots-nav',
            dots: true,
            fade:false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                        arrows:false,
                    }
                }
            ],
        });

        slider.on('afterChange', function(event, slick, currentSlide){
            var imageNext = $('.slick-slide.slick-current').next().css('background-image');
            var imagePrev = $('.slick-slide.slick-current').prev().css('background-image');

            $(this).find('.vk-arrow.next .image-preview-thumbnail').css('background-image',imageNext);
            $(this).find('.vk-arrow.prev .image-preview-thumbnail').css('background-image',imagePrev);
        });

        function doAnimations(elements) {
            var animationEndEvents = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
            elements.each(function() {
                var $this = $(this);
                var $animationDelay = $this.data('delay');
                var $animationType = 'animated ' + $this.data('animation');
                $this.css({
                    'animation-delay': $animationDelay,
                    '-webkit-animation-delay': $animationDelay,
                    'display':'inline-block',
                });
                $this.addClass($animationType).one(animationEndEvents, function() {
                    $this.removeClass($animationType);
                });
            });
        }

    }


    var _initInstances = function () {
        imageSlider();
        homepageSlider();
        singleProjectSlider();
        aboutPageSlider();
        homeShopSlider();
        singleProductSlider();
        homeOnePage();
        homeOnePageExtra();
        homeSlider();
    };

    return {
        init: function () {
            _initInstances();
        },
        responsive: function () {
            homeOnePage();
        }
    };
}();
$(document).ready(function () {
    Slider.init();
});

/*-------------Gallery-----------------*/
$(document).ready(function () {
    var Conclave=(function(){
        var buArr =[],arlen;
        return {
            init:function(){
                this.addCN();this.clickReg();
            },
            addCN:function(){
                var buarr=["holder_bu_awayL2","holder_bu_awayL1","holder_bu_center","holder_bu_awayR1","holder_bu_awayR2"];
                for(var i=1;i<=buarr.length;++i){
                    $("#bu"+i).removeClass().addClass(buarr[i-1]+" holder_bu");
                }
            },
            clickReg:function(){
                $(".holder_bu").each(function(){
                    buArr.push($(this).attr('class'))
                });
                arlen=buArr.length;
                for(var i=0;i<arlen;++i){
                    buArr[i]=buArr[i].replace(" holder_bu","")
                };
                $(".holder_bu").on('click', function(buid){
                    var me=this,id=this.id||buid,joId=$("#"+id),joCN=joId.attr("class").replace(" holder_bu","");
                    var cpos=buArr.indexOf(joCN),mpos=buArr.indexOf("holder_bu_center");
                    if(cpos!=mpos){
                        tomove=cpos>mpos?arlen-cpos+mpos:mpos-cpos;
                        while(tomove){
                            var t=buArr.shift();
                            buArr.push(t);
                            for(var i=1;i<=arlen;++i){
                                $("#bu"+i).removeClass().addClass(buArr[i-1]+" holder_bu");
                            }
                            --tomove;
                        }
                    }
                })
            },
            auto:function(){
                for(i=1;i<=1;++i){
                    $(".holder_bu").delay(4000).trigger('click',"bu"+i).delay(4000);
                    console.log("called");
                }
            }
        };
    })();

    $(document).ready(function(){
        window['conclave']=Conclave;
        Conclave.init();
    })
});

/*search*/
jQuery(document).ready(function ($) {
    jQuery('#search-click').on('click', function(event) {
        "use strict";
        jQuery('.close-search').fadeIn();
        jQuery('.search').css('visibility', 'visible');
        jQuery('.search-field').removeClass('none-search');
        jQuery('.search-field').addClass('block-search');
        return false;
    });
    jQuery('.close-search').on('click', function(event) {
        "use strict";
        jQuery('.close-search').hide();
        jQuery('.search').css('visibility', 'hidden');
        jQuery('.search-field').removeClass('block-search');
        jQuery('.search-field').addClass('none-search');
        return false;
    });
    /*filter price*/
    jQuery(".range-filter-input").asRange({
        range: true,
        limit: false
    });
});
